import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';

const StyledNameCell = styled(NameCell)`
  padding-left: var(--spacing-07);
`;

export const TitleCell: FC<{ title: ReactNode }> = ({ title }) => (
  <StyledNameCell logo="" primaryText={title} />
);
